/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import PropTypes from 'prop-types';
import { NotebookPen } from 'lucide-react';

const NotesButton = ({ onClick, overlay = false }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Notes"
    className={`flex justify-center w-5 h-5 rounded-full transition-colors active:scale-95 ${overlay && 'bg-black/20 text-white'}`}
  >
    <NotebookPen size={18} strokeWidth={2} />
  </button>
);

export default NotesButton;

NotesButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  overlay: PropTypes.bool,
};
